export default "__VITE_ASSET__DJtV1UdF__"